export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f2e8cc67f5744dd11b6660a64655c2816d9fe0a6d&name=fetchTypeahead!'